import * as _ from 'lodash';
import * as loggingModule from './logging';

function tryThis<T>(action: () => T | null) {
    try {
        return action();
    } catch (error) {}
}

function elapsedTimeFrom(startTime: number) {
    return () => {
        if (!startTime) {
            return null;
        }
        const endTime = performance.now();
        return endTime - startTime;
    };
}

export function TrackProcess(processName: string, options: TrackProcessOptions = {}) {
    const { shouldAwait, logging }: TrackProcessOptions = _.defaults(options, {
        shouldAwait: true,
        logging: loggingModule
    });
    return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
        const original = descriptor.value;

        descriptor.value = async function (...args) {
            tryThis(() => logging.info(`${processName} process started`, { args }));
            const startTime = tryThis(() => performance.now());

            let processResult;
            try {
                processResult = shouldAwait ? await original.apply(this, args) : original.apply(this, args);
            } catch (error) {
                const elapsedTimeMS = tryThis(elapsedTimeFrom(startTime));

                tryThis(() => logging.error(`${processName} process failed`, { error, elapsedTimeMS }));
                throw error;
            }

            const elapsedTimeMS = tryThis(elapsedTimeFrom(startTime));
            tryThis(() =>
                logging.info(`${processName} process finished successfully`, {
                    processResult,
                    elapsedTimeMS
                })
            );
            return processResult;
        };
    };
}

type TrackProcessOptions = { shouldAwait?: boolean; logging?: TrackLogger };

type TrackLogger = { info: (message, context) => void; error: (message, context) => void };
